import { PageHeader } from 'components/ui/PageHeader'
import { Outlet } from 'react-router'

export const AuthenticatedLayout = () => {
  return (
    <div
      className="tw-w-full tw-min-h-screen"
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        height: '100%',
      }}
    >
      <PageHeader />
      <div className="tw-w-full tw-p-4">
        <Outlet />
      </div>
    </div>
  )
}
